import React from "react";
import CustomToast from "components/common/CustomToast";
import { chatTypes } from "redux//Ldb/types";
import { toast } from "react-hot-toast";
import { chatService } from "services/Ldb";
import { Dispatch } from "redux";

export const chatActions = {
    createConversation,
    resetCreateConversationSuccess,
    getSingleConversation,
    getAllConversations,
    sendAiMessage,
    resetSendAiMessageSuccess,
    updateChatData,
    resetUpdateChatDataSuccess,
};

function createConversation(data: Record<string, any> | Array<Record<string, any>>) {
    return (dispatch: Dispatch) => {
        dispatch(request(chatTypes.CREATE_CONVERSATION_REQUEST));

        chatService.createConversation(data).then(
            (res) => {
                dispatch(success(chatTypes.CREATE_CONVERSATION_SUCCESS, res?.data));
            },
            (error) => {
                if (error.message) {
                    toast.custom((t) => (
                        <CustomToast t={t} message={error?.message} type="error" />
                    ));
                    dispatch(failure(chatTypes.CREATE_CONVERSATION_FAILURE, error?.message));
                }
            }
        );
    };
}

function getSingleConversation(conversationId: string) {
    return (dispatch: Dispatch) => {
        dispatch(request(chatTypes.FETCH_CONVERSATION_REQUEST));

        chatService.getConversation(conversationId).then(
            (res) => {
                dispatch(success(chatTypes.FETCH_CONVERSATION_SUCCESS, res?.data));
            },
            (error) => {
                if (error.message) {
                    toast.custom((t) => (
                        <CustomToast t={t} message={error?.message} type="error" />
                    ));
                    dispatch(failure(chatTypes.FETCH_CONVERSATION_FAILURE, error?.message));
                }
            }
        );
    };
}

function getAllConversations(limit?: number | string) {
    return (dispatch: Dispatch) => {
        dispatch(request(chatTypes.FETCH_ALL_CONVERSATIONS_REQUEST));

        chatService.getAllConversations(limit).then(
            (res) => {
                dispatch(success(chatTypes.FETCH_ALL_CONVERSATIONS_SUCCESS, res?.data));
            },
            (error) => {
                if (error.message) {
                    toast.custom((t) => (
                        <CustomToast t={t} message={error?.message} type="error" />
                    ));
                    dispatch(failure(chatTypes.FETCH_ALL_CONVERSATIONS_FAILURE, error?.message));
                }
            }
        );
    };
}

function sendAiMessage(
    data: Record<string, any> | Array<Record<string, any>>,
    setChats: React.Dispatch<React.SetStateAction<any[]>>
) {
    return (dispatch: Dispatch) => {
        dispatch(request(chatTypes.SEND_AI_CHAT_REQUEST));

        chatService.sendChat(data).then(
            (res) => {
                dispatch(success(chatTypes.SEND_AI_CHAT_SUCCESS, res?.data));
                setTimeout(() => {
                    setChats((prev) => [
                        ...prev,
                        {
                            loading: true,
                            conversationId: (data as Record<string, any>)?.conversationId,
                        },
                    ]);
                }, 500);
            },
            (error) => {
                if (error.message) {
                    toast.custom((t) => (
                        <CustomToast t={t} message={error?.message} type="error" />
                    ));
                    dispatch(failure(chatTypes.SEND_AI_CHAT_FAILURE, error?.message));
                }
            }
        );
    };
}

function updateChatData(data: Record<string, any> | Array<Record<string, any>>) {
    return (dispatch: Dispatch) => {
        dispatch(request(chatTypes.UPDATE_CHAT_DATA_REQUEST));

        chatService.updateChatData(data).then(
            (res) => {
                dispatch(success(chatTypes.UPDATE_CHAT_DATA_SUCCESS, res?.data));
            },
            (error) => {
                if (error.message) {
                    toast.custom((t) => (
                        <CustomToast t={t} message={error?.message} type="error" />
                    ));
                    dispatch(failure(chatTypes.UPDATE_CHAT_DATA_FAILURE, error?.message));
                }
            }
        );
    };
}

function resetCreateConversationSuccess() {
    return (dispatch: Dispatch) => {
        dispatch(success(chatTypes.CREATE_CONVERSATION_SUCCESS, null));
    };
}

function resetSendAiMessageSuccess() {
    return (dispatch: Dispatch) => {
        dispatch(success(chatTypes.SEND_AI_CHAT_SUCCESS, null));
    };
}

function resetUpdateChatDataSuccess() {
    return (dispatch: Dispatch) => {
        dispatch(success(chatTypes.UPDATE_CHAT_DATA_SUCCESS, null));
    };
}

function request(type: string) {
    return { type: type };
}
function success(type: string, data?: any) {
    return { type: type, payload: data };
}
function failure(type: string, error?: any) {
    return { type: type, payload: error ?? "" };
}
